import { render, staticRenderFns } from "./MarqueeBox.vue?vue&type=template&id=11bc34b0&scoped=true"
import script from "./MarqueeBox.vue?vue&type=script&lang=js"
export * from "./MarqueeBox.vue?vue&type=script&lang=js"
import style0 from "./MarqueeBox.vue?vue&type=style&index=0&id=11bc34b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bc34b0",
  null
  
)

export default component.exports